export default "__VITE_ASSET__Cqi4Ole5__"